// Test IDs for the admin leads dashboard (/admin). Naming follows the directive
// in ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const ADMIN = {
  loginForm: "admin-login-form",
  usernameInput: "admin-username-input",
  passwordInput: "admin-password-input",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",
  table: "admin-leads-table",
  row: "admin-leads-row",
  search: "admin-leads-search",
  refresh: "admin-leads-refresh",
  exportCsv: "admin-leads-export-csv",
  signOut: "admin-sign-out",
  empty: "admin-leads-empty",
  error: "admin-leads-error",
};
